import { render } from "./LyricsPage.vue?vue&type=template&id=04aafb65"
import script from "./LyricsPage.vue?vue&type=script&lang=js"
export * from "./LyricsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__